import _ from "lodash";
import React from "react";
import update from "immutability-helper";
import client from "lib/apolloClient/client";
import {
  getConfigurationQuery,
  getPreferenceQuery,
} from "./TeacherPortfolioQueries";
import { updateConfigurationMutation } from "./TeacherPortfolioMutations";
let store;
import("store/createStore").then(importedModule => {
  store = importedModule.store;
});
import i18next from "i18next";
import {
  handleAdminSidebarBackButtonClick,
  handleAdminSidebarMenuItemClick,
} from "Login/routes/Administrator/modules/AdministratorModule";
import BulkApplyColumnAction from "../components/commonComponents/BulkApplyColumnAction";
import { isPortfolioParityEnabled } from "Post/utils";
// Constants
export const NAME = "teacherPortfolio";

export const SET_TEACHER_PORTFOLIO_DATA =
  "SET_TEACHER_PORTFOLIO_DATA" + " " + NAME;

export const UPDATE_TEACHER_PORTFOLIO_DATA =
  "UPDATE_TEACHER_PORTFOLIO_DATA" + " " + NAME;

export const DESELECT_ALL = "DESELECT_ALL" + " " + NAME;

export const SAVE_PORTFOLIO_DATA = "SAVE_PORTFOLIO_DATA" + " " + NAME;
export const SET_EDIT_MODE = "SET_EDIT_MODE" + " " + NAME;

export const SET_DISCARD_DIALOG = "SET_DISCARD_DIALOG" + " " + NAME;
export const UPDATE_PORTFOLIO_TYPE = "UPDATE_PORTFOLIO_TYPE" + " " + NAME;
export const UPDATE_BULK_PORTFOLIO_TYPE =
  "UPDATE_BULK_PORTFOLIO_TYPE" + " " + NAME;

// Actions creators

export const teacherPortfolioReducer = (state, action) => {
  const { type, payload } = action;
  const updatedState = _.cloneDeep(state);

  switch (type) {
    case SET_TEACHER_PORTFOLIO_DATA: {
      const { initialPortfolioPermissionData } = payload;
      return initialPortfolioPermissionData;
    }
    case UPDATE_TEACHER_PORTFOLIO_DATA: {
      const { id, columnId, columnData, setChangedData, changedData } = payload;

      const index = updatedState.findIndex(
        item => _.first(_.keys(item)) === id
      );
      _.set(updatedState[index][id].data, columnId, columnData);
      const changedGradeIds = [...changedData];
      changedGradeIds.push(updatedState[index]);
      setChangedData(changedGradeIds);
      return updatedState;
    }
    case UPDATE_PORTFOLIO_TYPE: {
      const { key: columnId, grade: id, setChangedData, changedData } = payload;
      const index = updatedState.findIndex(
        item => _.first(_.keys(item)) === id
      );

      if (columnId === "senior") {
        _.set(updatedState[index][id].data, "type", columnId);
        _.set(updatedState[index][id].data, "colSpan", 11);
      } else {
        _.set(updatedState[index][id].data, "type", columnId);
        _.set(updatedState[index][id].data, "colSpan", 1);
      }
      const changedGradeIds = [...changedData];
      changedGradeIds.push(updatedState[index]);
      setChangedData(changedGradeIds);
      return updatedState;
    }
    case UPDATE_BULK_PORTFOLIO_TYPE: {
      const { key: columnId, setChangedData, changedData } = payload;
      const changedGradeIds = [...changedData];
      const updatedFeedData = _.map(updatedState, item => {
        const updatedFeedDataObject = { ...item };
        if (columnId === "senior") {
          _.set(
            updatedFeedDataObject[_.keys(updatedFeedDataObject)[0]].data,
            "type",
            columnId
          );
          _.set(
            updatedFeedDataObject[_.keys(updatedFeedDataObject)[0]].data,
            "colSpan",
            11
          );
        } else {
          _.set(
            updatedFeedDataObject[_.keys(updatedFeedDataObject)[0]].data,
            "type",
            columnId
          );
          _.set(
            updatedFeedDataObject[_.keys(updatedFeedDataObject)[0]].data,
            "colSpan",
            1
          );
        }
        changedGradeIds.push(item);
        return updatedFeedDataObject;
      });

      setChangedData([...changedGradeIds]);
      return updatedFeedData;
    }
    case DESELECT_ALL: {
      const {
        mediaType,
        isSelected,
        setChangedData,
        changedData,
        isPermissableCurriculum,
      } = payload;
      const changedGradeIds = [...changedData];
      const updatedFeedData = _.map(updatedState, item => {
        const updatedFeedDataObject = { ...item };
        if (
          isPermissableCurriculum ||
          _.first(_.values(updatedFeedDataObject)).data[mediaType] !== "null"
        ) {
          _.set(
            _.first(_.values(updatedFeedDataObject)).data,
            mediaType,
            !isSelected
          );
          changedGradeIds.push(item);
        }
        return updatedFeedDataObject;
      });
      setChangedData([...changedGradeIds]);
      return updatedFeedData;
    }
    default: {
      return updatedState;
    }
  }
};

export const MEDIA_TYPES = [
  "photo",
  "video",
  "audio",
  "file",
  "note",
  "collage",
  "link",
  "workbook",
];

export const ACTIVITY_MEDIA_OPTIONS = ["toilet", "food", "nap"];

export const PORTFOLIO_HEADER_COLUMNS = (
  isPypCurriculum,
  isEditMode,
  setChangedData,
  changedData,
  dispatch,
  containerRef
) => {
  const columnList = [
    {
      id: "grades",
      key: "grades",
      locale: "common:grades",
      entity: "TEACHER",
      parent: "root",
      children: [],
      level: 0,
      value: "grades",
      rowSpan: 2,
      type: "TEXTCOLUMN",
      isSticky: true,
      colSpan: 1,
    },
    // Keeping this for future reference (DP Parity)
    // {
    //   id: "type",
    //   entity: "TEACHER",
    //   parent: "root",
    //   label: "Portfolio type",
    //   key: "type",
    //   children: [],
    //   level: 0,
    //   isSticky: true,
    //   value: "type",
    //   rowSpan: 2,
    //   tooltip: "hello",
    //   colSpan: 1,
    //   type: "CUSTOM",
    //   style: {
    //     minWidth: "200px",
    //   },
    //   changedData,
    //   setChangedData,
    //   headerRightComponentStyle: { marginLeft: "4px" },
    //   HeaderRightComponent: () => (
    //     <BulkApplyColumnAction
    //       changedData={changedData}
    //       setChangedData={setChangedData}
    //       dispatch={dispatch}
    //       containerRef={containerRef}
    //       isEditMode={isEditMode}
    //     />
    //   ),
    // },
    {
      id: "mediaTypes",
      entity: "mediaTypes",
      parent: "root",
      locale: "configuration:media_types",
      children: MEDIA_TYPES,
      level: 0,
      value: "mediaTypes",
      rowSpan: 2,
      colSpan: 8,
    },
  ];
  if (isPortfolioParityEnabled()) {
    const portfolioTypeObject = {
      id: "type",
      entity: "TEACHER",
      parent: "root",
      label: "Portfolio type",
      key: "type",
      children: [],
      level: 0,
      isSticky: true,
      value: "type",
      rowSpan: 2,
      tooltip: "hello",
      colSpan: 1,
      type: "CUSTOM",
      style: {
        minWidth: "200px",
      },
      changedData,
      setChangedData,
      headerRightComponentStyle: { marginLeft: "4px" },
      HeaderRightComponent: () => (
        <BulkApplyColumnAction
          changedData={changedData}
          setChangedData={setChangedData}
          dispatch={dispatch}
          containerRef={containerRef}
          isEditMode={isEditMode}
        />
      ),
    };
    columnList.splice(1, 0, portfolioTypeObject);
  }
  if (isPypCurriculum) {
    columnList.push({
      id: "activityTypes",
      entity: "activityTypes",
      parent: "root",
      locale: "configuration:activity_types",
      children: ACTIVITY_MEDIA_OPTIONS,
      level: 0,
      value: "activityTypes",
      rowSpan: 2,
    });
  }
  return columnList;
};

export const createConfigurationFilters = gradeIds => {
  const filters = [];
  _.map(gradeIds, gradeId => {
    filters.push({
      configurationEntityGroups: [
        {
          entityId: gradeId,
          entityType: "GRADE",
        },
      ],
      configurationGroups: ["PortfolioManager"],
    });
  });
  return filters;
};

export const getConfigurationFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getConfigurationQuery,
      variables: variables,
    });
    return queryData;
  } catch (error) {
    return {};
  }
};

export const getPreferenceFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPreferenceQuery,
      variables: variables,
    });
    return queryData;
  } catch (error) {
    return {};
  }
};

const createConfigDataObject = item => {
  const configData = {};
  configData.type = _.first(_.values(item)).data.type;
  configData.data = _.omit(_.first(_.values(item)).data, [
    "id",
    "grades",
    "type",
    "colSpan",
  ]);
  return JSON.stringify(configData);
};

const createConfigValueObject = (data, isStudent) => {
  const configData = [];
  _.map(data, item => {
    const configItem = {};
    configItem.id = isStudent ? "4721" : "4723";
    configItem.valueType = "JSON";
    configItem.entityGroups = [
      {
        entityId: _.first(_.keys(item)),
        entityType: "GRADE",
      },
    ];
    configItem.value = createConfigDataObject(item);
    configData.push(configItem);
  });
  return configData;
};

export const updateConfigurationValue = payload => {
  const {
    changedData,
    setChangedData,
    organizationGradeIds,
    isStudent,
  } = payload;
  return async () => {
    try {
      if (!_.isEmpty(changedData)) {
        await client.mutate({
          mutation: updateConfigurationMutation,
          variables: {
            input: createConfigValueObject(
              _.reverse(
                _.uniqBy(_.reverse(changedData), item => _.first(_.keys(item)))
              ),
              isStudent
            ),
          },
          optimisticResponse: {
            __typename: "Mutation",
            platform: {
              __typename: "SchoolMutations",
              platform: {
                setMultipleConfigurationValueForEntityGroups: true,
                __typename: "PlatformMutations",
              },
            },
          },
          awaitRefetchQueries: true,
          refetchQueries: [
            {
              query: getConfigurationQuery,
              variables: {
                configurationEntityGroupFilters: createConfigurationFilters(
                  organizationGradeIds
                ),
                isAdminPage: true,
                isSettingsPage: false,
              },
            },
          ],
          update: (cache, { data }) => {
            const { platform } = data;
            const { setMultipleConfigurationValueForEntityGroups } = platform;
            setMultipleConfigurationValueForEntityGroups && setChangedData([]);
          },
        });
      }
    } catch (error) {}
  };
};

export const teacherPortfolioLeaveInterceptor = ({
  destinationNode,
  source,
}) => {
  const state = store?.getState() ?? {};
  const dispatch = store?.dispatch;
  const isEditMode = _.get(state, "teacherPortfolio.isEditMode");

  if (isEditMode) {
    const onDiscardConfirm = () => {
      if (source === "SIDEBAR_MENU") {
        const t = i18next.t;
        dispatch(
          handleAdminSidebarMenuItemClick({ t, key: destinationNode.uid })
        );
        return;
      }
      if (source === "SIDEBAR_BACK") {
        dispatch(handleAdminSidebarBackButtonClick());
        return;
      }
    };
    dispatch({
      type: SET_DISCARD_DIALOG,
      payload: {
        showDiscardDialog: store?.getState().teacherPortfolio.isEditMode,
        onDiscardConfirm,
      },
    });
  }
  return !isEditMode;
};

export const setEditMode = data => {
  return {
    type: SET_EDIT_MODE,
    payload: data,
  };
};

export const bulkApplyColumnAction = data => {
  return {
    type: UPDATE_BULK_PORTFOLIO_TYPE,
    payload: data,
  };
};

export const setEditAction = payload => {
  return async dispatch => {
    dispatch(setEditMode(payload));
  };
};

export const setDiscardDialog = data => {
  return {
    type: SET_DISCARD_DIALOG,
    payload: data,
  };
};

export const getPortfolioTypeDropOptions = ({ t }) => {
  return [
    {
      key: "junior",
      value: "junior",
      label: t("journal:junior_portfolio"),
      subText: t("journal:junior_folio_subtext"),
    },
    {
      key: "senior",
      value: "senior",
      label: t("journal:senior_portfolio"),
      subText: t("journal:senior_folio_subtext"),
    },
  ];
};
const REDUCER_HANDLERS = {
  [SET_EDIT_MODE]: (state, action) => {
    state = update(state, {
      isEditMode: { $set: action.payload },
    });
    return state;
  },
  [SET_DISCARD_DIALOG]: (state, action) => {
    const { payload } = action;
    if (_.isEmpty(payload) || _.isUndefined(payload)) {
      return update(state, {
        discardDialog: { $set: initialState.discardDialog },
      });
    }
    state = update(state, {
      discardDialog: { $set: payload },
    });
    return state;
  },
};

// Initial State and export Reducer
const initialState = {
  isEditMode: false,
  discardDialog: { showDiscardDialog: false, onDiscardConfirm: () => {} },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
